import { render } from "./day_logo.vue?vue&type=template&id=6db8b69f"
import script from "./day_logo.vue?vue&type=script&lang=js"
export * from "./day_logo.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__